// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './bot-messages-api';

export const useListBotGroups: typeof hookExports.useListBotGroups = hookExports.useListBotGroups;
export const useLazyListBotGroups: typeof hookExports.useLazyListBotGroups =
  hookExports.useLazyListBotGroups;
export const useListBotMessages: typeof hookExports.useListBotMessages =
  hookExports.useListBotMessages;
export const useLazyListBotMessages: typeof hookExports.useLazyListBotMessages =
  hookExports.useLazyListBotMessages;
